import { Link, NavLink } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { Button } from './ui/button';
import { Feather, MapTrifold, MagnifyingGlass, User, SignOut, ChatCircleText, Plus } from '@phosphor-icons/react';
import NotificationBell from './NotificationBell';

export default function Header({ onOpenChat }) {
  const { user, login, logout } = useAuth();
  return (
    <header className="glass-nav sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-24 flex items-center justify-between">
        <Link to="/" className="flex items-center group" data-testid="header-logo">
          <img
            src="/logo.png"
            alt="Pow Wow Finder"
            className="h-16 sm:h-20 w-auto group-hover:scale-105 transition-transform"
          />
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-sm">
          <NavLink to="/events" className={({isActive}) => `hover:text-terracotta transition-colors ${isActive ? 'text-terracotta' : ''}`} data-testid="nav-events">
            Events
          </NavLink>
          <NavLink to="/map" className={({isActive}) => `hover:text-terracotta transition-colors ${isActive ? 'text-terracotta' : ''}`} data-testid="nav-map">
            Map
          </NavLink>
          <NavLink to="/plan" className={({isActive}) => `hover:text-terracotta transition-colors ${isActive ? 'text-terracotta' : ''}`} data-testid="nav-plan">
            Trip Planner
          </NavLink>
          <NavLink to="/submit" className={({isActive}) => `hover:text-terracotta transition-colors ${isActive ? 'text-terracotta' : ''}`} data-testid="nav-submit">
            Submit Event
          </NavLink>
          <button onClick={onOpenChat} className="hover:text-terracotta transition-colors flex items-center gap-1.5" data-testid="nav-ai-chat">
            <ChatCircleText size={18} weight="duotone" /> Ask Guide
          </button>
        </nav>
        <div className="flex items-center gap-2">
          {user && <NotificationBell />}
          {user ? (
            <div className="flex items-center gap-2">
              <Link to="/dashboard" data-testid="header-dashboard-link">
                <Button variant="ghost" size="sm" className="rounded-full">
                  {user.picture ? (
                    <img src={user.picture} alt="" className="w-7 h-7 rounded-full" />
                  ) : (
                    <User size={18} />
                  )}
                  <span className="hidden sm:inline ml-2">{user.name?.split(' ')[0]}</span>
                </Button>
              </Link>
              <Link to="/organizer" className="hidden md:inline-flex">
                <Button variant="ghost" size="sm" className="rounded-full" data-testid="header-organizer-link">My events</Button>
              </Link>
              {user.role === 'admin' && (
                <Link to="/admin">
                  <Button variant="outline" size="sm" className="rounded-full" data-testid="header-admin-link">Admin</Button>
                </Link>
              )}
              <Button onClick={logout} variant="ghost" size="sm" className="rounded-full" data-testid="header-logout">
                <SignOut size={18} />
              </Button>
            </div>
          ) : (
            <Button
              onClick={login}
              className="bg-turquoise hover:bg-turquoise/90 text-navy rounded-full px-5 font-semibold"
              data-testid="header-login-btn"
            >
              Sign in
            </Button>
          )}
        </div>
      </div>
    </header>
  );
}
